/* mixins/utility */
export default {
	methods: {
		getDistinctList(list, property, sort = false) {
			let arr = [... new Set(list.flatMap(item => (item === null || item[property] === null) ? [] : [item[property]]))]

			if (sort) {
				return arr.sort((a, b) => {
					let aVal = a.toString().toUpperCase()
					let bVal = b.toString().toUpperCase()

					if (aVal < bVal)
						return -1
					if (aVal > bVal)
						return 1
					return 0
				})
			}

			return arr
		},

		getInitials(displayName) {
			if (!displayName) return ''

			let split = displayName.split(' ')
			let initials = ''

			split.forEach(name => initials += name.charAt(0))

			return initials
		}
	}
}